import styled from 'styled-components'

export const WrapperLateral = styled.div`
  width: 100%;
  max-height: 55vh;
  overflow-y: auto;
  padding-right: 5px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }

  .button__eye{
    padding: 8px;
    border-radius: 6px;
    width: 35px;
    /* não encolhe quando o nome da análise é longo */
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #5da57d;
    border: 2px solid #5da57d;
  }

  .button__eye:hover {
    background-color: var(--cor-do-item);
    border: 2px solid  var(--cor-do-item);
    color: white;
  }

  .button__eye:is([data-active='true']) {
    background-color: var(--cor-do-item);
    border: 2px solid  var(--cor-do-item);
    color: white;
  }

  .fundo__lateral {
    width: 100%;
    height: calc(100vh - 167px);
    border: 2px solid #d9d9d9;
    padding: 10px;
    border-radius: 8px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 10px;

    .card__analise {
      border: 2px solid #d9d9d9;
      padding: 10px;
      border-radius: 8px;
      display: flex;
      flex-direction: column;
      gap: 10px;

      .title__analises {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    }

    .points-grid {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
    }

    .point-card {
      background-color: var(--cor-do-item);
      color: white;
      border: 2px solid var(--cor-do-item);
      font-weight: 700;
      font-size: 12px;
      width: 30px !important;
      height: 30px;
      border-radius: 6px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 10px;
    }
  }

  .ant-collapse-content-box {
    padding: 10px !important;
  }

  .container__adicionados {
    width: 100%;
    display: flex;
    flex-direction: column;
    border: 2px solid #d9d9d9;
    padding: 10px;
    border-radius: 8px;
    gap: 5px;
  }

  /* Rótulo do painel: "análise | profundidade". A análise é o que distingue os
     itens (a mesma profundidade se repete), então ela leva o destaque. */
  .lateral__rotulo {
    display: flex;
    align-items: center;
    gap: 6px;
    min-width: 0;
    font-size: 13px;
  }

  .lateral__rotulo__analise {
    font-weight: 700;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .lateral__rotulo__separador {
    color: #bdbdbd;
    font-weight: 400;
  }

  .lateral__rotulo__profundidade {
    font-weight: 600;
    color: #757575;
    white-space: nowrap;
  }

  .points-title {
    color: #757575;
    font-size: 12px;
    font-weight: 700;
    margin: 0;
    padding: 0;
  }

  .points-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  .point-card {
    background-color: var(--cor-do-item);
    color: white;
    border: 2px solid var(--cor-do-item);
    font-weight: 700;
    font-size: 12px;
    width: 30px !important;
    height: 30px;
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 10px;
  }

  .point-card:hover {
    transition: 0.5s;
    transform: scale(1.05);
    background-color: var(--cor-do-item);
    border: 2px solid var(--cor-do-item);
    color: white;
  }
`
